<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row>
        <b-col cols="2">
          <date-picker
            id="dpRoster"
            v-model="searchData.date"
            :lang="lang"
            type="month"
            format="YYYY-MM"
            :disabled="mode == 'new' ? false : true"
            v-bind:clearable="false"
            @change="changeDate"
          ></date-picker>
        </b-col>
        <b-col cols="2">
          <b-form-select v-model="searchData.compCode" @change="changeComp">
            <option value selected>
              --- {{ this.t.t(dictEnum.LBL_Company) }} ---
            </option>
            <option
              v-for="(comp, index) in compList"
              :key="index"
              :value="comp.CompCode"
            >
              {{ user.Lang == "EN" ? comp.EName : comp.CName }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="2">
          <b-form-select v-model="searchData.deptID">
            <option value selected>
              --- {{ this.t.t(dictEnum.LBL_Department) }} ---
            </option>
            <option
              v-for="(dept, deptIndex) in departmentList"
              :key="deptIndex"
              :value="dept.Dept"
            >
              {{ user.Lang == "EN" ? dept.EDesc : dept.CDesc }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="2">
          <b-form-input
            size="sm"
            maxlength="80"
            length="80"
            v-model="searchData.staffName"
            :placeholder="'--- ' + this.t.t(dictEnum.LBL_Staff) + ' ---'"
          ></b-form-input>
          <button
            type="button"
            style="margin-top: -54px; margin-left: 200px"
            class="btn btn-transparent"
            v-on:click="OnStaffBtnClick()"
          >
            <img src="../../../static/images/search.png" class="w-14" />
          </button>
        </b-col>
        <b-col cols="1">
          <button
            type="button"
            class="btn btn-info p-1"
            v-on:click="getDataTable()"
          >
            {{ `${this.t.t(dictEnum.LBL_SearchStaff)} ` }}
          </button>
        </b-col>
        <b-col
          cols="3"
          class="text-right"
          v-if="
            hasRight(Settings.Permission.Change) &&
              hasRight(Settings.Permission.Write)
          "
        >
          <button class="btn btn-info" v-b-modal.modal-month>
            <!-- @click="openGenRoster" -->
            {{ `${this.t.t(dictEnum.BTN_AutoGen)} ` }}
          </button>
          <FileReader
            v-if="hasRight(Settings.Permission.Import)"
            @load="importData"
            accept=".txt,.xlsx,xls"
          ></FileReader>
          <button
            v-if="hasRight(Settings.Permission.Delete)"
            class="btn btn-danger"
            @click="deleteRoster"
          >
            {{ `${this.t.t(dictEnum.BTN_Delete)} ` }}
          </button>
          <button
            v-if="hasRight(Settings.Permission.Write)"
            class="btn btn-primary"
            @click="saveRoster"
          >
            {{ `${this.t.t(dictEnum.BTN_Save)} ` }}
          </button>
          <button
            v-if="hasRight(Settings.Permission.Export)"
            class="btn btn-info"
            @click="ExportTableData"
          >
            {{ `${this.t.t(dictEnum.BTN_Export)} ` }}
          </button>
        </b-col>
      </b-row>
      <b-row class="h-100">
        <b-col cols="12" class="h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-100">
              <table class="DataTable">
                <thead>
                  <tr>
                    <th class="stickyHead"></th>
                    <th class="stickyHead"></th>
                    <th
                      v-for="(head, headIndex) in tableHeader"
                      :key="headIndex"
                      :style="
                        `background-color:${getWeek(head) == 'S' ? 'red' : ''}`
                      "
                    >
                      {{ getWeek(head) }}
                    </th>
                  </tr>
                  <tr>
                    <th class="stickyHead">{{ this.t.t(dictEnum.LBL_ID) }}</th>
                    <th class="stickyHead">
                      {{ this.t.t(dictEnum.LBL_Name) }}
                    </th>
                    <th
                      v-for="(head, headIndex) in tableHeader"
                      :key="headIndex"
                    >
                      {{ getDay(head) }}
                    </th>
                  </tr>
                </thead>
                <tr v-for="(staff, staffIndex) in tableData" :key="staffIndex">
                  <td class="stickyTd">{{ staff.StaffID }}</td>
                  <td class="stickyTd">
                    {{ user.Lang == "EN" ? staff.EngName : staff.ChiName }}
                  </td>
                  <td
                    v-for="(rosterValue, rosterIndex) in staff.Roster"
                    :key="rosterIndex"
                    :style="
                      `background:${routerShareColor(rosterValue.ShiftCode)}`
                    "
                    @click="editRoster(rosterValue)"
                  >
                    <b-form-select
                      style="text-align-last: center"
                      v-model="rosterValue.ShiftCode"
                      :options="shiftTypeList"
                      value-field="ShiftCode"
                      text-field="ShiftCode"
                    >
                    </b-form-select>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- genRoster Modal Start -->
    <!-- <div
      class="modal fade"
      id="genModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="genModel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-220" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.LBL_AutoGen) }}
            </h5>
          </div>
          <div class="modal-body p-2" style="width:80%;text-align:center">
            <date-picker
              id="dpRoster"
              v-model="genRosterDate"
              :lang="lang"
              type="month"
              format="YYYY-MM"
              :disabled="mode == 'new' ? false : true"
              v-bind:clearable="false"
              @change="changeDate"
            ></date-picker>
          </div>
          <div>
            <v-btn color="blue darken-1" text @click="hideGenRoster">
              {{ `${this.t.t(dictEnum.BTN_Cancel)} ` }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="genRoster">
              {{ `${this.t.t(dictEnum.BTN_Save)} ` }}
            </v-btn>
          </div>
        </div>
      </div>
    </div> -->
    <b-modal
      id="modal-month"
      :title="t.t(dictEnum.LBL_AutoGen)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="genRoster"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            {{ t.t(dictEnum.LBL_Month) }}
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <date-picker
                id="dpRoster"
                v-model="genRosterDate"
                :lang="lang"
                type="month"
                format="YYYY-MM"
                :disabled="mode == 'new' ? false : true"
                v-bind:clearable="false"
                @change="changeDate"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!-- genRoster Modal End -->
    <!-- Staff  Modal Start -->
    <div
      class="modal fade"
      id="staffModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="staffModel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-820" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.BTN_AutoGen) }}
            </h5>
          </div>
          <div class="modal-search">
            <form class="form-inline">
              <div class="form-group mx-sm-3 mb-2 mt-2">
                <label for="inputPassword2" class="sr-only">search</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword2"
                  v-model="searchValue"
                  :placeholder="t.t(dictEnum.LBL_SearchStaff)"
                />
              </div>
            </form>
          </div>
          <div class="modal-body p-0">
            <v-simple-table
              class="table table-sm mb-0 modal-tbl"
              min-height="500"
              height="500"
            >
              <template>
                <thead>
                  <tr>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_UserChiname) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_EngName) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_Job) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in StaffList"
                    v-on:click="OnStaffSelect(item)"
                    :key="index"
                  >
                    <td width="15%">{{ item.StaffID }}</td>
                    <td width="20%">
                      {{ `${item.ChiLastName}${item.ChiName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.EngName} ${item.EngLastName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.JobTitle}` }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Staff Modal End -->
  </div>
</template>

<script>
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import RosterService from "@/service/RosterService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Roster } from "@/model/Roster";
import DatePicker from "vue2-datepicker";
import { datePickerLang } from "@/constants/globalConstants";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import FileReader from "@/components/FileReader";
import ShiftTypeService from "@/service/ShiftTypeService";
import readXlsxFile from "read-excel-file";
import ArrayHelper from "@/common/helper/ArrayHelper";
import router from "@/router";
import * as XLSX from "xlsx";
import Settings from "@/constants/Settings";
import StaffService from "@/service/StaffService";
export default {
  components: { DatePicker, FileReader },
  computed: {
    t() {
      return t;
    },

    user() {
      return this.$store.getters[StoreGetter.user];
    },

    StaffList() {
      let list = this.staffList;
      if (this.searchData.compCode) {
        list = list.filter(x => x.CompCode == this.searchData.compCode);
      }
      if (this.searchValue != "") {
        list = list.filter(x =>
          ArrayHelper.staffSearch(x, this.searchValue.toLowerCase())
        );
      }
      return list;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_Roster,
      Settings: Settings,
      dictEnum: dictEnum,
      columns: ["ShiftCode", "Description", "TimeFrom", "TimeTo", "Color"],
      tableData: [],
      options: {},
      mode: "new",
      roster: new Roster(),
      moment: moment,
      DateFrom: moment()
        .startOf("month")
        .toDate(),
      DateTo: moment()
        .endOf("month")
        .toDate(),
      searchData: {
        date: moment().format("YYYY-MM"),
        deptID: "",
        compCode: "",
        staffName: "",
        staffID: ""
      },
      genRosterDate: moment().format("YYYY-MM"),
      columnsexport: {
        StaffID: "StaffID",
        DateWork: "DateWork",
        ShiftCode: "ShiftCode"
      },
      departmentList: [],
      shiftTypeList: [],
      tableHeader: [],
      lang: datePickerLang,
      copyDetail: {},
      pasteList: [],
      compList: [],
      staffList: [],
      searchValue: ""
    };
  },
  methods: {
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    OnStaffBtnClick: function() {
      $("#staffModel").modal("show");
    },

    OnStaffSelect: function(model) {
      var self = this;
      if (self.$store.getters[StoreGetter.user].Lang == "EN") {
        self.searchData.staffName =
          model["EngName"] + " " + model["EngLastName"];
      } else {
        self.searchData.staffName = model["ChiLastName"] + model["ChiName"];
      }
      self.searchData.staffID = model["StaffID"];
      $("#staffModel").modal("hide");
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      const obj = {
        staffID: this.user.UserID,
        dateFrom: moment(this.DateFrom)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.DateTo)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffService.getStaffListOnDuty(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async saveRoster() {
      let list = [];
      this.tableData.forEach(x => {
        list = list.concat(x.Roster);
      });
      list = list.filter(x => x.ShiftCode);
      const obj = {
        lisRoster: list
      };

      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.CFM_Save)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const response = await RosterService.import(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },
    changeComp() {
      this.searchData.StaffName = "";
      this.searchData.StaffID = "";
    },

    editRoster(roster) {
      this.roster = roster;
    },

    getWeek(date) {
      let week = moment(date).day();
      const weekList = ["S", "M", "T", "W", "T", "F", "S"];
      const weekValue = weekList[week];
      return weekValue;
    },

    getDay(date) {
      return moment(date).format("MM-DD");
    },

    async getDepartmentList() {
      var obj = {};
      const response = await StaffEmploymentService.getAllDepartment(obj);
      if (response.data.IsSuccess) {
        this.departmentList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    openGenRoster() {
      $("#genModel").modal("show");
    },
    hideGenRoster() {
      $("#genModel").modal("hide");
    },
    async genRoster() {
      const obj = {
        compCode: this.searchData.compCode,
        subsidary:this.searchData.compCode,
        dept: this.searchData.deptID,
        staffID:this.searchData.staffID?[this.searchData.staffID]: this.staffList.map(item => item.StaffID),
        dateFrom: moment(this.genRosterDate)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.genRosterDate)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd)
      };
      const response = await RosterService.genRoster(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        $("#genModel").modal("hide");
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
        $("#genModel").modal("hide");
      }
    },
    async deleteRoster() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        if (this.roster.SysDB) {
          this.roster.DateWork = moment(this.roster.DateWork).format(
            Settings.DateTime.yyyymmdd
          );
          const obj = {
            roster: this.roster
          };

          const response = await RosterService.deleteRoster(obj);
          if (response.data.IsSuccess) {
            SweetAlertService.success("Success", response.data.Message);
            this.getDataTable();
          } else {
            SweetAlertService.warning("Warn", response.data.Message);
          }
        } else {
          this.roster.ShiftCode = "";
        }
      }
    },

    routerShareColor(result) {
      let color = "white";
      const find = this.shiftTypeList.find(x => {
        return x.ShiftCode == result;
      });
      if (find) {
        color = find.Color;
      }
      return color;
    },

    changeDate() {
      var self = this;
      self.searchData.staffName = "";
      self.searchData.staffID = "";
    },

    async getDataTable() {
      const obj = {
        date: moment(this.searchData.date).format("YYYY-MM"),
        deptID: this.searchData.deptID,
        compCode: this.searchData.compCode,
        staffID: this.searchData.staffID
      };

      const response = await RosterService.getRoster(obj);
      if (response.data.IsSuccess) {
        let staffDatas = response.data.Data;
        if (this.searchData.staffName != "") {
          staffDatas = staffDatas.filter(x =>
            ArrayHelper.wildCardSearch(x, this.searchData.staffName)
          );
        }

        const dataBet = await this.getDayHead(this.searchData.date);

        for (const staff of staffDatas) {
          const list = dataBet.map(x => {
            let roster = new Roster();
            roster.StaffID = staff.StaffID;
            roster.DateWork = x;
            staff.Roster.forEach(r => {
              if (moment(r.DateWork).format(Settings.DateTime.yyyymmdd) == x) {
                roster.ShiftCode = r.ShiftCode;
                roster.SysDB = true;
              }
            });
            return roster;
          });
          list = ArrayHelper.sortByKey(list, "DateWork");
          staff.Roster = list;
        }

        // staffDatas.forEach(x =>
        //   x.Roster.forEach(r => (r.SysDB = r.ShiftCode ? true : false))
        // );
        this.tableHeader = dataBet;
        this.tableData = staffDatas;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDayHead(date) {
      if (date) {
        let startDay = moment(date)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd);
        let endDay = moment(date)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd);
        let daylist = [];
        const days = moment(endDay).diff(startDay, "days");
        daylist.push(startDay);
        for (let i = 1; i <= days; i++) {
          daylist.push(
            moment(startDay)
              .add(i, "days")
              .format(Settings.DateTime.yyyymmdd)
          );
        }
        return daylist;
      }
    },

    async getShiftType() {
      const obj = {};

      const response = await ShiftTypeService.getShiftType(obj);

      if (response.data.IsSuccess) {
        this.shiftTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async ExportTableData() {
      if (!XLSX) return;
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        let list = [];
        this.tableData.forEach(x => {
          x.Roster.forEach(r => {
            if (r.ShiftCode) {
              list.push({
                StaffID: x.StaffID,
                StaffName: this.user.Lang == "EN" ? x.EngName : x.ChiName,
                DateWork: moment(r.DateWork).format(Settings.DateTime.yyyymmdd),
                ShiftCode: r.ShiftCode
              });
            }
          });
        });

        const worksheet = await XLSX.utils.json_to_sheet(list);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet);
        XLSX.writeFile(
          workbook,
          `Roster-${moment().format("yyyyMMDDHHmm")}.xlsx`
        );
      }
    },

    formatDate(numb) {
      const time = new Date((numb - 1) * 24 * 3600000 + 1);
      time.setYear(time.getFullYear() - 70);
      return moment(time, "YYYY-MM-DDTHH:mm:ss")
        .add(-8, "hours")
        .format(Settings.DateTime.yyyymmdd);
    },

    importData() {
      const input = $("#fileReader");
      readXlsxFile(input[0].files[0], { sheet: "Sheet1" }).then(async rows => {
        let importDataList = [];
        rows.splice(0, 1);
        for (let row of rows) {
          importDataList.push({
            StaffID: row[0],
            DateWork: moment(row[2]).format(Settings.DateTime.yyyymmdd),
            ShiftCode: row[3]
          });
        }
        const obj = {
          lisRoster: importDataList
        };
        const response = await RosterService.import(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      });
    }
  },
  mounted() {
    this.assignRights();
    this.getDepartmentList();
    this.getDataTable();
    this.getShiftType();
    this.getCompanyList();
    this.getStaffList();
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}

.DataTable {
  /*width: max-content;*/
  width: 100%;
}
.DataTable td,
th {
  text-align: center;
}

.DataTable td:nth-child(1) {
  position: sticky;
  left: 0px;
  width: 100px;
  text-align: left;
  background: white;
}

.DataTable td:nth-child(2) {
  position: sticky;
  left: 100px;
  width: 120px;
  text-align: left;
  background: white;
}

.DataTable td:nth-child(3) {
  position: sticky;
  left: 100px;
  width: calc(100%-420px);
  text-align: left;
  background: white;
}

.DataTable th:nth-child(1) {
  position: sticky;
  left: 0px;
  width: 100px;
  text-align: left;
  background: #5ba7be;
}

.DataTable th:nth-child(2) {
  position: sticky;
  left: 100px;
  width: 120px;
  text-align: left;
  background: #5ba7be;
}
.DataTable th:nth-child(3) {
  position: sticky;
  left: 100px;
  width: calc(100%-420px);
  text-align: left;
  background: #5ba7be;
}

.DataTable thead tr:nth-child(1) {
  position: sticky;
  top: 0px;
  width: 100px;
  background: #5ba7be;
  z-index: 10;
}

.DataTable thead tr:nth-child(2) {
  position: sticky;
  top: 0px;
  width: 120px;
  background: #5ba7be;
  z-index: 10;
}

.DataTable thead tr:nth-child(3) {
  position: sticky;
  top: 0px;
  width: calc(100%-420px);
  background: #5ba7be;
  z-index: 10;
}

.TableHead {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050700-Roster.vue